export default {
      id: "ic_info_modal_new-usage",
      viewBox: "0 0 56 56",
      url: "/" + "images/icons.3.109.2.svg#ic_info_modal_new-usage",
      toString: function () {
        return this.url;
      }
    }